import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const ProjectCard = ({ p, index }) => (
  <article
    data-testid={`project-card-${p.slug}`}
    className="h-full border border-border rounded-md bg-surface/40 hover:bg-surface hover:border-muted/40 p-6 flex flex-col gap-4"
  >
    <div className="flex items-center justify-between gap-3">
      <span
        className={`font-mono text-[10px] uppercase tracking-widest rounded-sm px-2 py-0.5 border ${
          p.flagship
            ? "border-accent text-accent bg-accent-glow"
            : "border-border text-muted"
        }`}
      >
        {p.tag}
      </span>
      <span className="font-mono text-xs text-muted tnum">
        P.{String(index + 1).padStart(2, "0")}
      </span>
    </div>
    <h3 className="font-mono text-lg sm:text-xl font-medium tracking-tight">
      {p.title}
    </h3>
    <p className="text-sm text-muted leading-relaxed">{p.description}</p>
    <dl className="grid grid-cols-2 gap-x-4 gap-y-2 border-t border-border-subtle pt-4">
      {p.metrics.map(([k, v]) => (
        <div key={k}>
          <dd className="font-mono text-base font-semibold tnum">{v}</dd>
          <dt className="font-mono text-[10px] uppercase tracking-widest text-muted">
            {k}
          </dt>
        </div>
      ))}
    </dl>
    <ul className="flex flex-wrap gap-1.5">
      {p.tech.map((t) => (
        <li
          key={t}
          className="font-mono text-[11px] text-muted border border-border-subtle rounded-sm px-1.5 py-0.5"
        >
          {t}
        </li>
      ))}
    </ul>
    <a
      href={p.url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`project-github-link-${p.slug}`}
      className="press mt-auto inline-flex items-center gap-1.5 font-mono text-xs text-muted hover:text-accent pt-1"
    >
      {p.url.replace("https://", "")}
      <ArrowUpRight size={13} aria-hidden="true" />
    </a>
  </article>
);

export const Projects = () => (
  <section
    id="projects"
    aria-labelledby="projects-heading"
    data-testid="projects-section"
    className="py-16 sm:py-24"
  >
    <SectionHeading index="02" id="projects-heading" title="Projects" sub="SELECTED BUILDS // 4 ENTRIES" />
    <div className="mt-10 grid grid-cols-1 md:grid-cols-12 gap-6">
      {PROJECTS.map((p, i) => (
        <Reveal
          key={p.slug}
          delay={i * 0.06}
          className={p.flagship ? "md:col-span-12" : "md:col-span-6"}
        >
          <ProjectCard p={p} index={i} />
        </Reveal>
      ))}
    </div>
  </section>
);
